import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
} from 'firebase/firestore'
import type { DocumentData, QueryDocumentSnapshot, Timestamp } from 'firebase/firestore'
import { db } from '../lib/firebase'
import type { Customer } from '../types/admin'

export const customersRef = collection(db, 'customers')

export function timestampToIso(value: unknown): string {
  if (!value) return ''
  const stamp = value as Timestamp
  if (typeof stamp?.toDate === 'function') return stamp.toDate().toISOString()
  if (typeof value === 'string') return value
  return ''
}

function toCustomer(snapshot: QueryDocumentSnapshot<DocumentData>): Customer {
  const data = snapshot.data()
  return {
    id: snapshot.id,
    name: data.name ?? '',
    phone: data.phone ?? '',
    email: data.email ?? '',
    address: data.address ?? '',
    notes: data.notes ?? '',
    createdAt: timestampToIso(data.createdAt),
  }
}

export function subscribeCustomers(
  onChange: (customers: Customer[]) => void,
  onError: (error: unknown) => void,
): () => void {
  return onSnapshot(
    query(customersRef, orderBy('name')),
    (snapshot) => onChange(snapshot.docs.map(toCustomer)),
    onError,
  )
}

export async function createCustomerDoc(customer: Omit<Customer, 'id' | 'createdAt'>): Promise<string> {
  const created = await addDoc(customersRef, { ...customer, createdAt: serverTimestamp() })
  return created.id
}

export async function updateCustomerDoc(id: string, patch: Partial<Customer>): Promise<void> {
  await updateDoc(doc(db, 'customers', id), { ...patch, updatedAt: serverTimestamp() })
}

export async function deleteCustomerDoc(id: string): Promise<void> {
  await deleteDoc(doc(db, 'customers', id))
}
